import PlurixHeader from "./PlurixHeader";
import PlurixFooter from "./PlurixFooter";
import "./PlurixContainer.scss";
import "./PlurixVoucherCode.scss";
import VoucherCode from "../../../../components/VoucherCode";

const PlurixContainer = ({ product }) => {
  return (
    <>
      <section className="plurix-container-full template-plurix">
        <section className="redemption-code-container ">
          <PlurixHeader />
          <div className="redemption-code-content row justify-content-center">
            <div className="vibe-redemption-code-card">
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="col-sm-4 text-center">
                    <img
                      className="voucher-image"
                      src={product.image?.medium || product.image?.original}
                      alt={product.name}
                    />
                  </div>
                  <div className="col-sm-8 mt-2 p-3">
                    <span className="voucher-title">{product.name}</span>
                    <p className="mt-4 text-plurix-info">
                      {product.productDescription}
                    </p>
                  </div>
                </div>

                <VoucherCode
                  code={product.codes.voucherCode}
                  pin={product.codes.voucherPinCode}
                  merchantId={product.merchantId}
                  link={product.codes.link}
                  showCodeMessage="Ver meu código"
                />

                <div className="row mt-3">
                  <div className="col text-center">
                    <p className="voucher-footer">
                      Válido para utilização exclusiva no App.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <PlurixFooter />
        </section>
      </section>
    </>
  );
};

export default PlurixContainer;
